import React, { useState, useEffect } from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import Footer from './components/Footer';
import Login from './components/Login';
import Dashboard from './pages/Dashboard';
import EmployeeManagement from './pages/EmployeeManagement';
import ScheduleGeneration from './pages/ScheduleGeneration';
import ScheduleView from './pages/ScheduleView';
import Settings from './pages/Settings';
import UserManagement from './components/UserManagement';
import DepartmentManagement from './components/DepartmentManagement';
import { AuthProvider, useAuth } from './context/AuthContext';
import { ScheduleProvider } from './context/ScheduleContext';
import './styles/neumorphism.css';

function AppContent() {
  const { isAuthenticated, loading, currentDepartment, user } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    // Apply neumorphic design theme to body
    document.body.className = 'bg-gray-50';
  }, []);
useEffect(() => {
    function sendHeight() {
      const height = document.documentElement.scrollHeight;
      window.parent.postMessage({ type: 'setHeight', height }, '*');
    }

    sendHeight();

    window.addEventListener('resize', sendHeight);

    const observer = new MutationObserver(sendHeight);
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });

    return () => {
      window.removeEventListener('resize', sendHeight);
      observer.disconnect();
    };
  }, []);
  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 mx-auto mb-4 rounded-full neu-element flex items-center justify-center">
            <div className="w-8 h-8 border-4 border-orange-600 border-t-transparent rounded-full animate-spin"></div>
          </div>
          <p className="text-gray-600">HelmPlanner wird geladen...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Login />;
  }

  // Check if user object exists and has required properties
  if (!user || Object.keys(user).length === 0) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-xl font-semibold text-gray-900 mb-2">Benutzerdaten nicht verfügbar</h2>
          <p className="text-gray-600">Es gab ein Problem beim Laden Ihrer Benutzerdaten. Bitte melden Sie sich erneut an.</p>
          <button
            onClick={() => window.location.reload()}
            className="mt-4 px-4 py-2 bg-orange-600 text-white rounded-lg hover:bg-orange-700"
          >
            Seite neu laden
          </button>
        </div>
      </div>
    );
  }

  if (!currentDepartment) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-xl font-semibold text-gray-900 mb-2">Keine Abteilung verfügbar</h2>
          <p className="text-gray-600">Sie haben keinen Zugriff auf eine Abteilung. Kontaktieren Sie Ihren Administrator.</p>
        </div>
      </div>
    );
  }

  return (
    <ScheduleProvider>
      <div className="min-h-screen bg-gray-50 flex flex-col">
        <Header onMenuClick={() => setSidebarOpen(!sidebarOpen)} />
        
        <div className="flex flex-1">
          <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
          
          <main className="flex-1 p-6 ml-0 lg:ml-64 transition-all duration-300 mt-20">
            <Routes>
              <Route path="/" element={<Dashboard />} />
              <Route path="/employees" element={<EmployeeManagement />} />
              <Route path="/generate" element={<ScheduleGeneration />} />
              <Route path="/schedule" element={<ScheduleView />} />
              <Route path="/settings" element={<Settings />} />
              <Route path="/users" element={<UserManagement />} />
              <Route path="/departments" element={<DepartmentManagement />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </main>
        </div>
        
        <Footer />
      </div>
    </ScheduleProvider>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

export default App;